import type { AiCostAudioPayload } from '@Application/AiCosts/Actions/aiCostSummaryFetched';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * Processed audios: `durationSeconds` is in seconds, `unpricedCount` counts the audios whose cost is
 * incomplete because at least one call has no price.
 */
class AiCostAudioView {
	readonly count: number;
	readonly durationSeconds: number;
	readonly costAmount: number;
	readonly unpricedCount: number;

	constructor(payload: AiCostAudioPayload) {
		this.count = payload.count;
		this.durationSeconds = payload.durationSeconds;
		this.costAmount = payload.cost;
		this.unpricedCount = payload.unpricedCount;

		Object.freeze(this);
	}

	/** Average over the priced audios only; `null` when none is priced. */
	get averageCost(): number | null {
		const pricedCount = this.count - this.unpricedCount;

		return pricedCount > 0 ? this.costAmount / pricedCount : null;
	}
}

export default AiCostAudioView;
